import React, {useEffect,useState,useContext,useRef} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import { useLocation,useParams, useNavigate, Outlet } from 'react-router-dom';
import { PiTag,PiTrash, PiUsersThreeLight, PiMaskHappyLight, PiPencilSimple, PiMaskHappy, PiProhibitLight, PiMoneyLight, PiPathLight, PiTagFill, PiTagLight} from 'react-icons/pi';
import {QuestionDialog, Detail, ContentContainer, ListItem, createDialog, ContentGroup} from 'coaz-ui';
import EditUserType from './EditUserType';
import AddTariff from './AddTariff';
import AddContextRole from './AddContextRole';
import client from '../client';
import UserItems from './UserItems';
import EditTariff from './EditTariff';


const UserType = () => {
    const {version,setVersion} = useContext(GlobalContext);
    const [userType,setUserType] = useState(null);
    const userTypeRef = useRef(null);
    const [ownerContextRoles,setOwnerContextRoles] = useState([]);
    const [tariffs,setTariffs] = useState([]);
    const [buttons,setButtons] = useState([]);
    const [tariffItemButtons,setTariffItemButtons] = useState(null);
    const [roleItemButtons,setRoleItemButtons] = useState(null);
    const [loading,setLoading] = useState(true);
    const {request,getCurrent,errorMessage} = client;
    const {userTypeId,roleId,userId} = useParams();
    const path = useLocation().pathname;

    const navigate = useNavigate();

    let USDecimal = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const onEdit = (e) => {
        e.preventDefault();
        createDialog({
            title:"Edit User Type",
            params:{id:userTypeId},
            Component:EditUserType,
            version:version,
            setVersion:setVersion
        })
    }
    
    const onAssignRole = (e) => {
        if(!userTypeRef.current || !userTypeRef.current.ref || !userTypeRef.current.ref.value) return;
        e.preventDefault();
        createDialog({
            title:"Add Context Role",
            params:{ownerReference:userTypeRef.current.ref.value},
            Component:AddContextRole,
            version:version,
            setVersion:setVersion
        })
    }

    const onAddTariff = (e) => {
        if(!userTypeRef.current || !userTypeRef.current.ref || !userTypeRef.current.ref.value) return;
        e.preventDefault();
        createDialog({
            title:"Add Tariff",
            params:{tariffableReference:userTypeRef.current.ref.value},
            Component:AddTariff,
            version:version,
            setVersion:setVersion
        })
    }

    const getUserType = async () => {

        const current = await getCurrent();

        if(!current) return;

        let updateAuth = current.authorities.find((auth) => {return auth.authority === 'USERTYPE:UPDATE'});
        let deleteContextAuth = current.authorities.find((auth) => {return auth.authority === 'CONTEXT:DELETE'});
        let createTariffAuth = current.authorities.find((auth) => {return auth.authority === 'TARIFF:CREATE'});
        let updateTariffAuth = current.authorities.find((auth) => {return auth.authority === 'TARIFF:UPDATE'});
        let deleteTariffAuth = current.authorities.find((auth) => {return auth.authority === 'TARIFF:DELETE'});

        if(userTypeId) {
            await request('GET',`usertypes/${userTypeId}`)
            .then((response) => {
                if(response) {
                    setUserType(response);
                    userTypeRef.current = response;
                    let btns = [];
                    let roleItemBtns = [];
                    let tariffItemBtns = [];
                    if(updateAuth) {
                        btns.push(
                            {
                                Icon:PiPencilSimple,
                                name:'Edit',
                                handler:onEdit
                            }
                        );

                        btns.push(
                            {
                                Icon:PiMaskHappy,
                                name:'Assign Role',
                                handler:onAssignRole
                            }
                        );
                    }

                    if(updateAuth && deleteContextAuth) {
                        roleItemBtns.push({
                            Icon:PiTrash,
                            name:'Delete Context Role',
                            handler:onDeleteContextRole
                        })
                    }
                    if(response.tariffApplicable) {
                        if(updateAuth && createTariffAuth) {
                            btns.push({
                                Icon:PiTag,
                                name:'Add Tariff',
                                handler:onAddTariff
                            })
                        }
                        if(updateAuth && updateTariffAuth) {
                            tariffItemBtns.push({
                                Icon:PiPencilSimple,
                                name:'Edit Tariff',
                                handler:onEditTariff
                            })
                        }
                        if(updateAuth && deleteTariffAuth) {
                            tariffItemBtns.push({
                                Icon:PiTrash,
                                name:'Delete Tariff',
                                handler:onDeleteTariff
                            })
                        }
                    }
                    setButtons(btns);
                    setRoleItemButtons(roleItemBtns);
                    setTariffItemButtons(tariffItemBtns);
                }  else {
                    setUserType(null);
                }
            })
            .catch((error) => {
                setUserType(null);
            })
        }
    }

    const getOwnerContextRoles = async () => {
        if(!userTypeRef.current || !userTypeRef.current.ref) return;
        await request('GET','ownercontextroles/by-owner',null,{ownerReference:userTypeRef.current.ref.value})
        .then((response) => {
            if(response) {
                setOwnerContextRoles(response);
            } else {
                setOwnerContextRoles([])
            }
        })
        .catch((error) => {
            setOwnerContextRoles([])
        })
    }

    const getTariffs = async () => {
        if(!userTypeRef.current || !userTypeRef.current.ref) return;
        request('GET',`tariffs/by-tariffable`,null,{tariffableReference:userTypeRef.current.ref.value})
        .then((response) => {
            if(response && response.length > 0) {
                setTariffs(response);
            } else {
                setTariffs([]);
            }
        })
        .catch((error) => {
            setTariffs([]);
        })
    }

    const onOpenRole = (item) => {
        if(!item || !item.id) return;
        let ids = item.id.split('-');
        if(ids.length < 3) return;
        navigate(`${path}/_role/${ids[2]}`)
    }

    const onOpenUser = (user) => {
        if(!user || !user.ref || !user.ref.id) return;

        navigate(`${path}/_user/${user.ref.id}`)
    }

    const onEditTariff = (item) => {
        if(!item || !item.id) return;
        
        let id = item.id.split('-');

        if(id && id.length && id.length > 1) {
            createDialog({
                title:"Add Tariff",
                params:{tariffableReference:id[0],criteriaValue:id[1]},
                Component:EditTariff,
                version:version,
                setVersion:setVersion
            })
        }
    }

    const onDeleteContextRole = (item) => {
        if(!item || !item.id) return;
        
        let id = item.id.split('-');

        if(id && id.length && id.length > 1) {
            createDialog({
                title:'Delete Context Role',
                submitText:"Yes",
                cancelText:"No",
                params:{
                    submit:async (e) => {
                            try {
                                await request('DELETE','ownercontextroles',null,{ownerReference:id[0], contextReference:id[1]});
                                return {
                                    message: 'Successful',
                                    success: true
                                };
                            } catch (error) {
                                return {
                                    message: errorMessage(error)
                                };
                            }
                        },
                    message:`Are you sure you want to delete ${item.text}?`
                },
                Component:QuestionDialog,
                version:version,
                setVersion:setVersion
            })
        }
    }

    const onDeleteTariff = (item) => {
        if(!item || !item.id) return;
        
        let id = item.id.split('-');

        if(id && id.length && id.length > 1) {
            createDialog({
                title:'Delete Tariff',
                submitText:"Yes",
                cancelText:"No",
                params:{
                    submit:async (e) => {
                            try {
                                await request('DELETE','tariffs',null,{tariffableReference:id[0], criteriaValue:id[1]});
                                return {
                                    message: 'Successful',
                                    success: true
                                };
                            } catch (error) {
                                return {
                                    message: errorMessage(error)
                                };
                            }
                        },
                    message:`Are you sure you want to delete ${item.text}?`
                },
                Component:QuestionDialog,
                version:version,
                setVersion:setVersion
            })
        }
    }

    const searchUsers = async (searchKey,page) => {
        let object = null;
        await request('GET','users/filter-page',null,{
            userTypeId:userTypeId,
            searchKey:searchKey,
            pageNo:page.pageNo,
            pageSize:page.pageSize
        })
        .then((response) => {
            if(response && response.content) {
                object = {
                    users:response.content,
                    pageNo:response.pageNo,
                    pageSize:response.pageSize,
                    totalElements:response.totalElements,
                    totalPages:response.totalPages,
                    last:response.last
                }
            } 
        })
        .catch((error) => {
            console.log(error);
        })
        return object
    }

    const load = async () => {
        setLoading(true);
        await getUserType();
        await getOwnerContextRoles();
        await getTariffs();
        setLoading(false);
    }

    useEffect(() => {
        load()
    },[version])

    if(roleId || userId) {
        return (
            <Outlet/>
        )
    } else {
        return (
            <ContentContainer buttons={buttons} 
                Icon={PiUsersThreeLight} 
                text={userType?userType.name:''} 
                subText={userType?userType.description:''} 
                scrollable={true}
                background={true}
                loading={loading}>
                {userType &&
                <div className='flex flex-col w-full h-fit p-4 space-y-4'>
                    <div className='flex flex-col w-full h-auto space-y-2'>
                        <Detail Icon={PiProhibitLight} label='Reserved' value={userType.reserved?'Yes':'No'}/>
                        <Detail Icon={PiMoneyLight} label='Tariff Applicable' value={userType.tariffApplicable?'Yes':'No'}/>
                        {userType.tariffApplicable && userType.criteriaPathItemId &&
                            <Detail Icon={PiPathLight} label='Criteria Path' value={userType.criteriaPathItemId}/>
                        }
                    </div>
                    {ownerContextRoles && ownerContextRoles.length > 0 &&
                    <ContentGroup name='Context Roles'>
                        {ownerContextRoles.map((ownerContextRole,i) => 
                            <ListItem 
                                key={i} 
                                Icon={PiMaskHappyLight} 
                                item={{id:`${ownerContextRole.owner.ref.value}-${ownerContextRole.context}-${ownerContextRole.role.ref.id}`,
                                        text:ownerContextRole.context.toLowerCase(), 
                                        subText:ownerContextRole.role.name.toLowerCase(),
                                    }}
                                handleOpen={onOpenRole}
                                buttons={roleItemButtons}
                            />)}
                    </ContentGroup>
                    }
                    {userType.tariffApplicable && tariffs && tariffs.length > 0 &&
                    <ContentGroup name='Tariffs'>
                        {tariffs.map((tariff,i) => 
                        <ListItem 
                            key={i} 
                            Icon={tariff.default?PiTagFill:PiTagLight} 
                            item={{
                                id:`${tariff.tariffableReference}-${tariff.criteriaValue}`,
                                text:`K ${USDecimal.format(tariff.price)}`,
                                subText:`${tariff.criteria && tariff.criteria.name?tariff.criteria.name:tariff.criteriaValue}`}} 
                            buttons={tariffItemButtons}
                        />)}
                    </ContentGroup>
                    }
                    <ContentGroup name='Users'>
                        <UserItems 
                            onSelect={onOpenUser}
                            search={searchUsers}
                        />
                    </ContentGroup>
                </div>
                }
            </ContentContainer>
        )
    }
}

export default UserType
